import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, MessageCircle } from 'lucide-react';
import { useSettings } from '../../contexts/SettingsContext';

export default function Footer() {
  const { businessInfo } = useSettings();
  const phone = businessInfo?.phone || '+263-71-708-2807';
  const email = businessInfo?.email || 'info@gandimall.com';
  const address = businessInfo?.address || '33 Magamba Way, Chinhoyi';
  const whatsappUrl = `https://wa.me/${phone.replace(/\D/g, '')}`;

  return (
    <footer className="bg-ink text-stone-300">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-18">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <span className="text-2xl font-bold text-white">
                {businessInfo?.name || 'Gandi Mall'}
              </span>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed max-w-md">
              {businessInfo?.description ||
                'Modern retail and office spaces in Chinhoyi. Join our community of successful businesses.'}
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-white text-sm uppercase tracking-wider mb-4">
              Links
            </h4>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/shops" className="hover:text-white transition-colors">Shops</Link></li>
              <li><Link to="/client/login" className="hover:text-white transition-colors">Portal</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white text-sm uppercase tracking-wider mb-4">
              Contact
            </h4>
            <div className="space-y-3 text-sm">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#25D366] transition-colors">
                <MessageCircle size={18} /> WhatsApp
              </a>
              <a href={`tel:${phone.replace(/\s/g, '')}`} className="flex items-center gap-2 hover:text-white transition-colors">
                <Phone size={18} /> {phone}
              </a>
              <a href={`mailto:${email}`} className="flex items-center gap-2 hover:text-white transition-colors break-all">
                <Mail size={18} /> {email}
              </a>
              <div className="flex items-start gap-2 text-stone-400">
                <MapPin size={18} className="shrink-0 mt-0.5" /> {address}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-stone-500 text-sm">© {new Date().getFullYear()} Gandi Mall</p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-stone-500 hover:text-stone-400">Privacy</a>
            <a href="#" className="text-stone-500 hover:text-stone-400">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
